import { SET_VERSION_DATA } from "./types";

export function setVersionData(Data) {
    return {
        type: SET_VERSION_DATA,
        Data,
    };
};